import { createIcon } from "@chakra-ui/icons";

// Source: https://fontawesome.com/icons/biohazard?s=solid
export default createIcon({
  displayName: "WaveSin",
  viewBox: "0 0 640 512",
  path: (
    <path
      d="M638.6 297.2C633 315.9 580.4 480 463.1 480C346.4 480 294.5 285.9 288.1 263.8C275.2 209 229.5 96 176 96C117.1 96 73.34 197.6 62.67 233.2C57.57 250.1 39.75 259.7 22.83 254.7C5.889 249.6-3.72 231.7 1.358 214.8C6.983 196.1 59.56 32 176 32c117.6 0 169.5 194.1 175 216.3C364.8 302.1 410.5 416 463.1 416c58.92 0 102.7-101.6 113.3-137.2c5.109-16.94 22.97-26.44 39.84-21.47C634.1 262.4 643.7 280.3 638.6 297.2z"
      fill="currentColor"
    />
  ),
});
